import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useList } from '../api/queries'
import type { Equipment } from '../api/types'
import { Card, EmptyState, ErrorState, LoadingState, PageHeader, SearchBox } from '../components/ui'
import { useDebounced } from '../lib/hooks'

export function NewInspectionPage() {
  const [search, setSearch] = useState('')
  const q = useDebounced(search)
  const list = useList<Equipment>('/api/equipment/', { search: q, page_size: 20 })
  const rows = list.data?.results.filter((e) => e.code) ?? []
  return (
    <div className="page">
      <PageHeader title="Nueva inspección" subtitle="Elegí el equipo a inspeccionar" />
      <Card>
        <div className="toolbar"><SearchBox label="Buscar equipo" value={search} onChange={setSearch} placeholder="Código o nombre" /></div>
        {list.isPending ? <LoadingState label="Cargando equipos…" /> : list.isError ? <ErrorState error={list.error} onRetry={() => void list.refetch()} /> : rows.length === 0 ? <EmptyState title="Sin equipos" /> : (
          <ul className="stack">
            {rows.map((e) => <li key={e.id}><Link className="btn btn--ghost" to={`/e/${e.code}/inspect`}><span className="mono">{e.code}</span> · {e.name} · {e.area_name}</Link></li>)}
          </ul>
        )}
      </Card>
    </div>
  )
}
